module.exports = __webpack_public_path__ + "media/img/favicon/android-chrome-144x144-e151f04d788c1737bce11f5086d03bdc.png";